import { animate, motion, useMotionValue } from "framer-motion";
import { Parameter } from "./types/goal-parameters";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "src/components/ui/Card";
import { useEffect, useState } from "react";

interface Props {
  param: Parameter;
  progress: number;
  index: number;
}

const ProgressCard = ({ param, progress, index }: Props) => {
  const count = useMotionValue(0);
  // const rounded = useTransform(count, (v) => Math.round(safeNumber(v)));
  const [value, setValue] = useState(0);

  useEffect(() => {
    const controls = animate(count, progress, {
      duration: 1.2,
      delay: index * 0.1 + 0.2,
      ease: "easeOut",
      onUpdate: (v) => setValue(v), // drives the bar
    });
    return controls.stop;
  }, [progress, index, count]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
    >
      <Card className="rounded-2xl shadow-md hover:shadow-lg transition-all">
        <CardHeader>
          <CardTitle className="text-md font-semibold text-primary">
            {param.name}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center gap-2">
            <span className="text-xl font-bold text-primary">
              <motion.span>
                {param.achieved} / {param.target} {param.unit}
              </motion.span>
            </span>
            <progress
              className="progress w-56"
              value={value}
              max="100"
            ></progress>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ProgressCard;
